import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { IS_DEV_MODE } from "../../util/helpers";
import { fetchAndActivate, getRemoteConfig } from "firebase/remote-config";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyCUUIe0mgfdUA9FW7nN0TtdfF9nQi88GwQ",
  authDomain: "ar-codestone.firebaseapp.com",
  projectId: "ar-codestone",
  storageBucket: "ar-codestone.appspot.com",
  messagingSenderId: "915723205500",
  appId: "1:915723205500:web:e0fa500759d1dd4aa082f9",
  measurementId: "G-3T8KBXB51K",
};

declare global {
  // eslint-disable-next-line no-var
  var FIREBASE_APPCHECK_DEBUG_TOKEN: boolean | string | undefined;
}

// Initialize Firebase
export const app = ((window.FIREBASE_APPCHECK_DEBUG_TOKEN = IS_DEV_MODE), initializeApp(firebaseConfig));

// Reverted back to the classic v3 provider (the "RememQR" Website/Score
// key) after switching to ReCaptchaEnterpriseProvider broke sign-in
// site-wide: Firebase's own token-exchange endpoint
// (exchangeRecaptchaEnterpriseToken) started returning 500s for every
// caller, not just Maps, which throttled App Check entirely and blocked
// login. Whatever's misconfigured on the Enterprise registration side
// needs to be sorted out (and re-verified with a real sign-in test, not
// just a Maps load) before trying that switch again - this key/provider
// pairing is the one actually confirmed working end-to-end.
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LcLVeIqAAAAAKvgnObhz8yakmxqCTu5dizLyAHP"),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);

// export const analytics = getAnalytics(app);
// export const logAnalytic = (message: string) => {
//   logEvent(analytics, message);
// };

// Initialize Remote Config and get a reference to the service
export const remoteConfig = getRemoteConfig(app);
// Determine how long data is cached - in milisecs
remoteConfig.settings.minimumFetchIntervalMillis = IS_DEV_MODE ? 0 : 10000;
// Assign the default values
remoteConfig.defaultConfig = require("./remote-config-defaults.json");
// Get latest from server. Exported so callers can await it before reading a
// value with getValue() - otherwise a component that reads on first render
// almost always sees the bundled default, not the live remote value, since
// this fetch hasn't resolved yet.
export const remoteConfigReady = fetchAndActivate(remoteConfig).catch((err) => console.error(err));
